import { Search, RotateCcw } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from '@/components/ui/select'

export interface GiftProductFilterValues {
	name?: string
	state?: string
}

interface GiftProductFilterBarProps {
	value: GiftProductFilterValues
	onChange: (value: GiftProductFilterValues) => void
	onSearch: () => void
	onReset: () => void
	loading?: boolean
	actions?: React.ReactNode
}

export function GiftProductFilterBar({
	value,
	onChange,
	onSearch,
	onReset,
	loading = false,
	actions,
}: GiftProductFilterBarProps) {
	return (
		<div data-testid="gift-product-filter-bar" className="rounded-lg border bg-card p-4">
			<div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
				<div className="flex flex-wrap items-center gap-3">
					<div className="relative w-72 max-w-full">
						<Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
						<Input
							value={value.name ?? ''}
							onChange={(event) => onChange({ ...value, name: event.target.value })}
							onKeyDown={(event) => {
								if (event.key === 'Enter') onSearch()
							}}
							placeholder="搜索礼物名称"
							className="pl-9"
						/>
					</div>
					<Select
						value={value.state ?? 'all'}
						onValueChange={(state) => onChange({ ...value, state: state === 'all' ? '' : state })}
					>
						<SelectTrigger className="w-36" aria-label="状态">
							<SelectValue />
						</SelectTrigger>
						<SelectContent>
							<SelectItem value="all">全部状态</SelectItem>
							<SelectItem value="0">上架</SelectItem>
							<SelectItem value="1">下架</SelectItem>
						</SelectContent>
					</Select>
					<Button type="button" size="sm" onClick={onSearch} disabled={loading}>
						<Search className="mr-1.5 h-4 w-4" />
						查询
					</Button>
					<Button type="button" size="sm" variant="outline" onClick={onReset} disabled={loading}>
						<RotateCcw className="mr-1.5 h-4 w-4" />
						重置
					</Button>
				</div>
				{actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
			</div>
		</div>
	)
}
